import discoverNav from '@/components/discoverNav'
// import UserFollowBtn from "@/components/UserFollowBtn"
import RadialProgress from '../../components/radialProgressbar'


export default {
    components: {
      discoverNav,
      RadialProgress,
    },
  
    data() {
      return {
        data: true,
      }
    },
  }


// WEBPACK FOOTER //
// ./src/views/chartPage/index.ctrl.js